import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=3669fbb0"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"
import style0 from "./Legal.vue?vue&type=style&index=0&id=3669fbb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports